<template>
  <v-container>
    <h1>{{ get("header-1") }}</h1>
    <parameter ref="param" @error="onError" @data="onData" @id="onId"></parameter>
  </v-container>
</template>

<script>
import accountService from "@/_services/api/account-service";
import localizationMixin from "@/mixins/localization-mixin";
import paramCtrl from "@/components/controls/parameter";
import settingsService from "@/_services/settings-service";

export default {
  
  name: "account-loggedin",

  components: {
    "parameter": paramCtrl,
  },

  created() {
    this.pageName = "logged-in";
  },


  data: () => ({
    user: {
      id: "",
      username: "",
    },
  }),

  mixins: [localizationMixin],

  mounted() {
    // console.log("loggedIn.mounted()", this.$route.params.id);
    this.$refs.param.get(this.$route.params.id)
    // const id = this.$route.params.id;
    // user.cancelUrl = settingsService.get("cancelUrl");
    // user.password = "";
    // user.process = "login";
    // user.returnUrl = settingsService.get("remoteVerifiedUrl");
    // user.title = "Verify Login";
    // console.log("User:", user);
    // var token = tokenService.encrypt(user);
    // window.location.href = settingsService.get("remoteVerifyUrl") + token;
  },

  methods: {
    onApplicationSuccess(result){
      console.log(result);
      const application = result.data;
      if(application.enforce2PartyAuth) {
        this.verify();
      }
    },

    onApplicationError(error){
      console.log(error);
    },

    onData(data) {
      console.log("Data:", data);
      this.user = JSON.parse(data.jsonData);
      accountService.get("application/" + settingsService.get("applicationId"), this.onApplicationSuccess, this.onApplicationError)
    },

    onError(error) {
      console.log(error);
    },

    getLocalization(){},

    verify() {
      const data = {
        cancelUrl: settingsService.get("cancelUrl"),
        process: "verify",
        returnUrl: settingsService.get("verifiedUrl"),
        userId: this.user.id,
        username: this.user.userName,
      };
      console.log("loggedIn.verify() ", data);
      this.$refs.param.create(data);
    },

    onId(id) {
      window.location.href = settingsService.get("remoteVerifyUrl") + id;
    },
  }
}
</script>

<style>

</style>